import { I18n } from "@assets/strings";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useIsPerson } from "@domain/currentProfile/hooks";
import { Author } from "@domain/lms/content";
import { fullName } from "@domain/user/utils";

interface SubAuthorProps extends React.HTMLAttributes<HTMLDivElement> {
	author: Author;
	displayAuthorAsMe?: boolean;
}
export const SubAuthor: React.FC<SubAuthorProps> = ({ author, displayAuthorAsMe, ...htmlProps }) => {
	const history = useHistory();
	const isAuthor = useIsPerson(author);

	return (
		<Container
			{...htmlProps}
			onClick={(e) => {
				e.preventDefault();
				history.push(Path.Profile(author));
			}}
		>
			<span>
				{I18n.t("course.thumbnail.from")}{" "}
				{isAuthor && displayAuthorAsMe ? I18n.t("course.thumbnail.you") : fullName(author)}
			</span>
		</Container>
	);
};

const Container = styled.div`
	font-weight: 500;
`;
